import { normalizePartnerSlug } from "@/lib/partners/partner-slug-cookie"

export type PartnerSignupSource = "url" | "local_storage" | "cookie"

/**
 * Hierarquia na conclusão do cadastro:
 * 1. parâmetro `partner` na URL
 * 2. armazenamento local do navegador
 * 3. cookie
 */
export function resolvePartnerSlugAtSignup(input: {
  urlSlug: string | null | undefined
  localStorageSlug: string | null | undefined
  cookieSlug: string | null | undefined
}): { slug: string | null; source: PartnerSignupSource | null } {
  const url = normalizePartnerSlug(input.urlSlug)
  if (url) return { slug: url, source: "url" }

  const ls = normalizePartnerSlug(input.localStorageSlug)
  if (ls) return { slug: ls, source: "local_storage" }

  const cookie = normalizePartnerSlug(input.cookieSlug)
  if (cookie) return { slug: cookie, source: "cookie" }

  return { slug: null, source: null }
}

export function resolvePartnerCapturedAtAtSignup(input: {
  hasUrlSlug: boolean
  localStorageCapturedAt: string | null | undefined
  now?: Date
}): string | null {
  if (input.hasUrlSlug) {
    return (input.now ?? new Date()).toISOString()
  }
  const raw = input.localStorageCapturedAt?.trim()
  return raw || null
}
